module.exports = __webpack_public_path__ + "static/img/lres5.93454a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/lres5.png
// module id = 3I1K
// module chunks = 1